import type { UUID } from '@/types/Id'

export const DELETE_KEYWORD: string = 'delete'
export const DEFAULT_WINDOW_WIDTH: number = 1512
export const DEFAULT_TABLE_WIDTH_OFFSET: number = 105

export const SUPPORT_EMAIL: string = 'support@sweetspot.so'

export const SWEETSPOT_SECURITY_OVERVIEW_URL = 'https://trust.sweetspot.so'

export const DEMO_URL = 'https://sweetspot.so/pricing'

export const NO_ASSIGNEE_ID = '00000000-0000-0000-0000-000000000000' as UUID
